import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/constants';

const initialState = {
  // no props synchronized with server, only custom props
  highestLevelEarned: 0,
  isQuestOnboardingCompleted: false,
  isPracticeOnboardingCompleted: false,
  isRepeatOnboarding: false, // true, if a user clicks Help button in the game header
  levelIdAfterOnboarding: null,
};

const gameDetailsReducer = (state = initialState, { gameId, type, payload = {} }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INIT_ONBOARDING_ROUND: {
      const { isRepeatOnboarding, levelIdAfterOnboarding } = payload;

      return {
        ...state,
        isRepeatOnboarding,
        levelIdAfterOnboarding,
      };
    }

    case REDUX_ACTIONS.UPDATE_PRACTICE_DETAILS: {
      const { highestLevelEarned } = payload;

      return {
        ...state,
        highestLevelEarned,
      };
    }
    case REDUX_ACTIONS.UPDATE_ONBOARDING_DETAILS: {
      const { isQuestWorkflow } = payload;

      return {
        ...state,
        isQuestOnboardingCompleted: isQuestWorkflow || state.isQuestOnboardingCompleted,
        isPracticeOnboardingCompleted: !isQuestWorkflow || state.isPracticeOnboardingCompleted,
      };
    }

    case REDUX_ACTIONS.DEV_TOGGLE_ONBOARDING: {
      const { isQuestWorkflow } = payload;

      const newState = isQuestWorkflow
        ? { isQuestOnboardingCompleted: !state.isQuestOnboardingCompleted }
        : { isPracticeOnboardingCompleted: !state.isPracticeOnboardingCompleted };

      return {
        ...state,
        ...newState,
      };
    }

    default:
      return state;
  }
};

export default gameDetailsReducer;
